module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('h2', [_vm._v("Troubleshooting")]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      active: _vm.user
    },
    attrs: {
      "to": "/troubleshooting",
      "href": "#"
    }
  }, [_vm._v("Users")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      active: _vm.location
    },
    attrs: {
      "to": "/troubleshootingloc",
      "href": "#"
    }
  }, [_vm._v("Location")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-50fb5e10!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TroubleshootingMenu.vue
// module id = 413
// module chunks = 2